/* Mirexa — JavaScript del tema (sin dependencias) */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || window.moneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return String(cents);
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(match[0], value);
  }
  window.formatMoney = formatMoney;

  /* ---------- Header: sombra al hacer scroll ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Aparición suave ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (window.Shopify && window.Shopify.designMode) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Selector de país: enviar al cambiar ---------- */
  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  /* ---------- Antes / después ---------- */
  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var range = slider.querySelector('input[type=range]');
    if (!range) return;
    var update = function () { slider.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', update);
    update();
  });

  /* ---------- Página de producto ---------- */
  document.querySelectorAll('[data-product]').forEach(initProduct);

  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var bundleIndex = parseInt(root.getAttribute('data-bundle-index'), 10);
    var baseUnitPrice = parseInt(root.getAttribute('data-base-unit-price'), 10) || 0;
    var labels = JSON.parse(root.querySelector('[data-labels]').textContent);

    /* Galería */
    var main = root.querySelector('[data-gallery-main]');
    var slides = main ? Array.prototype.slice.call(main.querySelectorAll('[data-media-id]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var counter = root.querySelector('[data-gallery-counter]');
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      var activeThumb = thumbs[i];
      if (activeThumb && activeThumb.parentNode) {
        var p = activeThumb.parentNode;
        var left = activeThumb.offsetLeft - p.clientWidth / 2 + activeThumb.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    function goTo(i, smooth) {
      if (!main || !slides.length) return;
      i = (i + slides.length) % slides.length;
      main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    if (main) {
      var t;
      main.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth);
          if (i !== current) setActive(i);
        }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    /* Zoom en modal */
    var modal = root.querySelector('[data-media-modal]');
    if (modal) {
      var modalImg = modal.querySelector('img');
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (!img) return;
        img.addEventListener('click', function () {
          modalImg.src = img.getAttribute('data-zoom') || img.currentSrc || img.src;
          modalImg.alt = img.alt;
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });
      var closeModal = function () { modal.classList.remove('is-open'); document.body.style.overflow = ''; };
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-modal-close]')) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }

    /* Variantes */
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

    function selectedOptions() {
      var opts = [];
      product.options.forEach(function (_, i) {
        var checked = root.querySelector('[data-option-index="' + i + '"]:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }
    function findVariantWith(opts, index, value) {
      var o = opts.slice(); o[index] = value;
      return findVariant(o);
    }

    function setText(sel, text) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; }); }
    function toggle(sel, show) { root.querySelectorAll(sel).forEach(function (el) { el.hidden = !show; }); }

    function updateBundles(opts) {
      if (isNaN(bundleIndex)) return;
      root.querySelectorAll('[data-option-index="' + bundleIndex + '"]').forEach(function (input) {
        var v = findVariantWith(opts, bundleIndex, input.value);
        var card = input.nextElementSibling;
        if (!v || !card) return;
        var units = parseInt(input.getAttribute('data-units'), 10) || 1;
        var priceEl = card.querySelector('[data-bundle-price]');
        var compareEl = card.querySelector('[data-bundle-compare]');
        var unitEl = card.querySelector('[data-bundle-unit]');
        var extraEl = card.querySelector('[data-bundle-extra]');
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          compareEl.hidden = !(v.compare_at_price > v.price);
          compareEl.textContent = v.compare_at_price ? formatMoney(v.compare_at_price) : '';
        }
        if (unitEl && units > 1) unitEl.textContent = labels.per_unit.replace('[price]', formatMoney(Math.round(v.price / units)));
        if (extraEl) {
          var extra = baseUnitPrice * units - v.price;
          extraEl.hidden = !(units > 1 && extra > 0);
          if (extra > 0) extraEl.textContent = labels.extra_saving.replace('[amount]', formatMoney(extra));
        }
      });
    }

    function updateAvailability(opts) {
      inputs.forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        var v = findVariantWith(opts, i, input.value);
        var label = input.nextElementSibling;
        if (label && label.classList.contains('variant-pill')) label.classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function onChange() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      updateAvailability(opts);
      updateBundles(opts);
      product.options.forEach(function (_, i) { setText('[data-selected-option="' + i + '"]', opts[i] || ''); });

      var buttons = root.querySelectorAll('[data-add-to-cart]');
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; b.querySelector('[data-atc-text]').textContent = labels.unavailable; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        b.querySelector('[data-atc-text]').textContent = variant.available ? labels.add_to_cart : labels.sold_out;
      });

      setText('[data-price]', formatMoney(variant.price));
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      toggle('[data-compare-wrap]', onSale);
      if (onSale) {
        setText('[data-compare]', formatMoney(variant.compare_at_price));
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        setText('[data-save-percent]', labels.save_percent.replace('[percent]', pct));
        setText('[data-save-amount]', labels.save.replace('[amount]', formatMoney(variant.compare_at_price - variant.price)));
      }

      if (variant.featured_media && main) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(variant.featured_media.id); });
        if (idx > -1) goTo(idx);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    inputs.forEach(function (input) { input.addEventListener('change', onChange); });

    /* Mostrar la foto de la variante seleccionada al cargar */
    if (idInput && main) {
      var initial = product.variants.find(function (v) { return String(v.id) === String(idInput.value); });
      if (initial && initial.featured_media) {
        var start = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(initial.featured_media.id); });
        if (start > 0) goTo(start, false);
      }
    }
    if (inputs.length) {
      var opts0 = selectedOptions();
      updateAvailability(opts0);
      updateBundles(opts0);
    }

    /* Cantidad */
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          val += btn.hasAttribute('data-qty-plus') ? 1 : -1;
          input.value = Math.max(1, val);
        });
      });
    });

    /* Botón fijo en móvil */
    var sticky = root.querySelector('[data-sticky-atc]');
    var mainBtn = root.querySelector('[data-main-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.site-footer');
      var mainVisible = true, footerVisible = false;
      var refresh = function () {
        var passed = mainBtn.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', !mainVisible && passed && !footerVisible);
      };
      new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; refresh(); }).observe(mainBtn);
      if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; refresh(); }).observe(footer);
      var stickyBtn = sticky.querySelector('button');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
    }
  }
})();
